import React from 'react';

const Loader = () => {
	return(
			<div className="ui active inline loader">
			</div>
	);
}

export default Loader;